import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'
import router from '../../../../router'

// Token Refresh
// let isAlreadyFetchingAccessToken = false
// let subscribers = []

// function onAccessTokenFetched (access_token) {
//   subscribers = subscribers.filter(callback => callback(access_token))
// }

// function addSubscriber (callback) {
//   subscribers.push(callback)
// }

export default {
  init () {
    console.log('running init jwt----')

    axios.interceptors.request.use(
      (config) => {
        if (!config.headers['X-NOINIT']) {
          const token = localStorage.getItem('accessToken')
          const businessTag = localStorage.getItem('businessTag')
          if (token && businessTag) {
            config.headers['Authorization'] = token
            config.headers['business'] = businessTag
          }
          console.log('checking to append token', token, config)
          // config.headers['Content-Type'] = 'application/json';
        }

        return config
      },
      (error) => {
        Promise.reject(error)
      }
    )


    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        // TODO - implement refresh token 
        // and lock screen timeout
        
        router.push('/pages/login')

        // if (!isAlreadyFetchingAccessToken) {
        //   isAlreadyFetchingAccessToken = true
        //   store.dispatch('auth/fetchAccessToken')
        //     .then((access_token) => {
        //       isAlreadyFetchingAccessToken = false
        //       onAccessTokenFetched(access_token)
        //     })
        // }

        // const retryOriginalRequest = new Promise((resolve) => {
        //   addSubscriber(access_token => {
        //     originalRequest.headers.Authorization = `Bearer ${access_token}`
        //     resolve(axios(originalRequest))
        //   })
        // })
        // return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login (email, pwd, business) {
    return axios.post('/lms/st/auth', { identity: email, password: pwd }, { headers: { business, 'X-NOINIT': true } })
  },
  registerUser (name, email, pwd) {
    return axios.post('/api/auth/register', {
      displayName: name,
      email,
      password: pwd
    })
  },
  refreshToken () {
    return axios.post('/api/auth/refresh-token', {accessToken: localStorage.getItem('accessToKen')})
  }
}
